<i18n src='../i18n/main.json'></i18n>
<i18n src='../i18n/items.json'></i18n>
<template>
<div id="properties" style="position: relative">
  <!-- <flash-message variant="success"></flash-message> -->
  <h1>{{$t('items')}}</h1>

  <div class="row">
    <button v-on:click="loadItemEditor(null, true)" class="btn btn-warning new">{{$t('new_item')}}</button>
  </div>
  <br>
  <sweet-modal ref="edit_item_modal">
    <h2>{{e_item_new == true ? $t('new_item') : $t('edit') }}</h2>

    <div class="row">
      <div class="form-group col-md-2">
        <label for="e_item_sku">{{$t('sku')}}</label>
        <input id="e_item_sku" v-model="e_item.sku" class="form-control">
      </div>
      <div class="form-group col-md-3">
        <label for="e_item_name">{{$t('name')}}</label>
        <input id="e_item_name" v-model="e_item.name" class="form-control">
        <!-- <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small> -->
      </div>
      <div class="form-group col-md-2">
        <label for="e_item_barcode">{{$t('barcode')}}</label>
        <input id="e_item_barcode" v-model="e_item.barcode" class="form-control">
      </div>
      <div class="form-group col-md-1">
        <label for="e_item_cost">{{$t('cost')}}</label>
        <input id="e_item_cost" v-model="e_item.cost" v-on:input="factor_key_manual" class="form-control">
      </div>
      <div class="form-group col-md-1">
        <label for="e_item_factor">%
          <span v-if="!e_item_new">{{factor_calc(e_item.price01, e_item.cost)}}</span>
        </label>
        <input id="e_item_factor" v-model="e_item.factor" v-on:keydown="factor_key_fn" v-on:input="factor_key_manual" placeholder=""
          class="form-control">
      </div>
      <div class="form-group col-md-1">
        <label for="e_item_price01">{{$t('price')}} 01</label>
        <input id="e_item_price01" v-model="e_item.price01" class="form-control">
      </div>
    </div>

    <div class="row">
      <div class="form-group col-md-2">
        <label for="e_item_category">{{$t('category')}}</label>
        <select v-model="e_item.category_id" class="form-control">
          <option v-for="(option, key) in categories" :value="option.id">{{$t(option.name)}}</option>
        </select>
      </div>
      <div class="form-group col-md-2">
        <label for="e_item_units_in_package">{{$t('units_in_package')}}</label>
        <input id="e_item_units_in_package" v-model="e_item.units_in_package" placeholder="" class="form-control">
      </div>

      <div class="form-group col-md-2">
        <label for="e_item_extra">{{$t('extra')}}</label>
        <input dir="ltr" id="e_item_extra" v-model="e_item.extra" placeholder="" class="form-control">
      </div>
    </div>



    <div class="form-group">
      <button class='btn btn-success' v-on:click="save_item">{{$t('save')}}</button>
    </div>
  </sweet-modal>

  <form v-on:submit.prevent class="form-inline">
    <div class="form-group">
      <label class="form-label" for="page_number">{{$t('browse')}}</label>
      <button v-on:click="pagination.page_number -= 1; loadItems();" :disabled="pagination.page_number == 1" class="btn btn-default">-</button>
      <input name="page_number" style="width: 70px;text-align: center;" v-on:keyup="keymonitor" type="text" :max="pagination.total_pages"
        v-model="pagination.page_number" :disabled=PageSelectisDisabled class="form-control center">
      <button v-on:click="pagination.page_number += 1; loadItems();" :disabled="pagination.total_pages == pagination.page_number"
        class="btn btn-default">+</button>
    </div>

    <div class="form-group">
      <label class="form-label" for="filter_name">{{$t('item_name')}}</label>
      <input id="filter_name" type="text" v-model="filter.name" class="form-control">
    </div>
    <div class="form-group">
      <label class="form-label" for="filter_sku">{{$t('code')}}</label>
      <input style="width: 100px;" id="filter_sku" type="text" v-model="filter.sku" class="form-control">
    </div>
    <div class="form-group">
      <label class="form-label" for="filter_category_id">{{$t('category')}}</label>
      <select v-model="filter.category_id" class="form-control" id="filter_category_id">
        <option :value="undefined"></option>
        <option v-for="(option, key) in categories" :value="option.id">{{$t(option.name)}}</option>
      </select>
    </div>

    <div class="form-group">
      <div class="totalPages">
        {{ totalPages }}
      </div>
    </div>
    <div class="form-group">
      <label class="form-label" for="per_page">{{$t('results_in_each_page')}}</label>
      <select style="width: 100px;" name="per_page" v-model="pagination.per_page" class="form-control center">
        <option disabled value="">נא לבחור אפשרות</option>
        <option>10</option>
        <option>25</option>
        <option>50</option>
        <option>100</option>
      </select>
    </div>
  </form>
  <br />

  <div style="overflow-x:auto">
    <table class="table listing table-striped">
      <thead>
        <tr class="bg alpha">
          <th>{{$t('sku')}}</th>
          <th>{{$t('barcode')}}</th>
          <th>{{$t('name')}}</th>
          <th>{{$t('units_in_package')}}</th>
          <th>{{$t('cost')}}</th>
          <th>{{$t('price')}} 01</th>
          <th>%</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item of items" :key="item.id" v-bind:class="{ pending: item.status == 0, approved: item.status == 2 }" v-tooltip="{content: itemTooltip(item), classes: ['static_tooltip']}">
          <td>
            <i :title="$t('edit')" v-on:click="loadItemEditor(item, false)" class="ti-pencil">&nbsp;</i>
            <span dir="ltr">{{ item.sku }}</span>

          </td>
          <td>{{ item.barcode }}</td>
          <td>
            <span v-if="hasUnicode(item.name)" dir="rtl">{{ item.name }}&nbsp;</span>
            <span v-if="!hasUnicode(item.name)" dir="ltr">&nbsp;{{ item.name }}</span>
            <span dir="ltr">
              <!-- <span v-if="item.size !== null" style="color:green;">&nbsp;S:{{ item.size }}</span>
              <span v-if="item.length !== null" style="color:red;">&nbsp;L:{{ item.length }}</span> -->
              <span v-if="item.extra !== null" style="color:blue;">&nbsp;E:{{ item.extra }}</span>
            </span>
          </td>
          <td>{{ item.units_in_package }}</td>
          <td>{{ item.cost }}</td>
          <td>{{ item.price01 }}</td>
          <td>{{factor_calc(item.price01, item.cost)}}</td>
        </tr>
        </tr>
      </tbody>
    </table>
  </div>
</div>
</template>

<script>
import { SweetModal } from 'sweet-modal-vue'

export default {
  components: {
    SweetModal
  },
  data() {
    return {
      categories: [],
      adding_item: false,
      e_item: [{ factor: 0 }],
      e_item_new: false,
      items: [],
      errors: [],
      filter: {
        name: '',
        sku: '',
        //inserted_at: moment().format('YYYY-MM-DD')
        inserted_at: '2017-10-01'
      },
      filter_objects: [],
      config: {
        format: 'YYYY-MM-DD',
        useCurrent: false
      },
      pagination: {
        page_number: '',
        total_pages: '',
        per_page: '100'
      },
      PageSelectisDisabled: false,
      unitTypes: null,
      factors: {
        F1: 10,
        F2: 20,
        F3: 30,
        F4: 40,
        F5: 50
      }
    }
  },
  computed: {
    tokenState() {
      return this.$ls.get('access_token')
    },
    totalPages() {
      return this.pagination.total_pages
    },
    Agent() {
      return this.$ls.get('agent')
    },
    locale() {
      return this.$store.getters.locale
    }
  },
  // Fetches posts when the component is created.
  created() {
    this.init()
    this.loadItems()
    this.$i18n.locale = this.$store.getters.locale
    this.$i18n.silentTranslationWarn = true
    this.loadTranslations()
    this.load_categories()
    this.unitTypes = {
      unit: this.$t('unit'),
      pair: this.$t('pair'),
      meter: this.$t('meter'),
      package: this.$t('package'),
      roll: this.$t('roll'),
      kg: this.$t('kg'),
      sqm: this.$t('sqm')
    }
    //  this.loadFilterObjects()
  },
  watch: {
    locale(locale) {
      this.$i18n.locale = locale
      this.loadTranslations()
    },
    'filter.name': function(val, oldVal) {
      this.loadItems()
    },
    'filter.sku': function(val, oldVal) {
      this.loadItems()
    },
    'filter.vendor_id': function(val, oldVal) {
      this.loadItems()
    },
    'e_item.factor': function(val, oldVal) {},

    // 'filter.user_id': function(val, oldVal) {
    //   this.loadItems()
    // },
    // 'pagination.per_page': function(val, oldVal) {
    //   this.loadItems()
    // },
    items: function(val, oldVal) {
      this.PageSelectisDisabled = false
    }
  },

  methods: {
    factor_calc: function(price, cost) {
      return ((price / cost) * 100 - 100).toFixed(2)
    },
    factor_key_fn: function(e) {
      if (this.factors[e.key] > 0) {
        this.e_item.factor = this.factors[e.key]

        if ([112, 113, 114, 115, 116].includes(e.keyCode)) {
          this.factor_key_manual()
          e.preventDefault()
        }
      } else {
      }
    },

    factor_key_manual: function(e) {
      this.e_item.price01 = (this.e_item.cost * ((100 + parseInt(this.e_item.factor)) / 100)).toFixed(2)
    },
    itemTooltip: function(item) {
      return `
      ${item.name}  <br />
      ${this.$t('sku')}: ${item.sku} <br />
      ${this.$t('serial')}: ${item.id}
      `
    },
    loadItems: function(e) {
      this.PageSelectisDisabled = true
      this.$axios
        .get(`/api/items`, {
          headers: this.authorization(),
          params: {
            page: this.pagination.page_number,
            per_page: this.pagination.per_page,
            name: this.filter.name,
            sku: this.filter.sku,
            vendor_id: this.filter.vendor_id,
            inserted_at: this.filter.inserted_at + ' 00:00:00'
            // user_id: this.filter.user_id
          }
        })
        .then(response => {
          console.log(response.data)
          // JSON responses are automatically parsed.
          this.items = response.data.items.entries

          this.pagination.page_number = response.data.items.page_number
          this.pagination.total_pages = response.data.items.total_pages
          if (this.pagination.page_number > this.pagination.total_pages) {
            this.pagination.page_number = 1
            this.loadItems()
          }
        })
        .catch(e => {
          this.errors.push(e)
          this.PageSelectisDisabled = false
        })
    },
    load_categories: function() {
      if (this.categories === undefined || this.categories.length == 0) {
        console.log('categories list is empty, let us load it from remote server..')
        var vm = this
        this.$axios
          .get(`/api/categories`, {
            headers: this.authorization(),
            params: { all: 'true' }
          })
          .then(response => {
            console.log(response.data.data)
            vm.categories = response.data.data
            //vm.new_book.language_id = 1
            // JSON responses are automatically parsed.
          })
          .catch(e => {
            this.errors.push(e)
            //this.PageSelectisDisabled = false
          })
      }
    },
    loadItemEditor: function(item, status) {
      this.e_item_new = status
      //this.load_languages()
      if (item == null) {
        item = { factor: 10 }
      }
      this.e_item = item
      console.log(this.e_item)
      this.$refs.edit_item_modal.open()
    },
    add_book: function() {
      // this.load_languages()
      this.adding_item = !this.adding_item
    },
    loadTranslations: function() {
      this.click_to_print_sticker = this.$t('click_to_print_sticker')
      this.number_of_results_pages = this.$t('number_of_results_pages')
      this.days_count = this.$t('days_count')
    },
    init: function() {
      //   this.logged_in_email = this.logged_in().as != null ? this.logged_in().as : "Guest"
    },
    keymonitor: function(event) {
      //console.log(event.key)
      if (event.key == 'Enter') {
        this.loadItems()
      }
    },
    /*
        stam: function(e) {
            this.$axios.get(`http://:/greet`, {

                })
                .then(response => {

                    console.log(response);
                })
                .catch(e => {
                    this.errors.push(e)
                    this.PageSelectisDisabled = false
                })
        },
        post: function(e) {
            this.$axios.post(`http://:/post`, {
                    Username: 2
                }, {
                    headers: this.authorization()
                })
                .then(response => {

                    console.log(response.data);

                })
                .catch(e => {
                    this.errors.push(e)
                    this.PageSelectisDisabled = false
                })
        },
        */

    save_item: function() {
      this.e_item_new == true ? this.create_item() : this.update_item()
    },

    create_item: function() {
      console.log('create_item..')
      var vm = this
      var item = this.e_item
      this.$axios
        .post(
          `/api/items`,
          {
            item
          },
          {
            headers: this.authorization()
          }
        )
        .then(response => {
          console.log(response)
          vm.$refs.edit_item_modal.close()
          this.loadItems()
        })
        .catch(e => {
          this.errors.push(e)
          this.PageSelectisDisabled = false
        })
    },

    update_item: function() {
      console.log('update_item..')
      var vm = this
      var item = this.e_item
      this.$axios
        .put(
          `/api/items/` + item.id,
          {
            item
          },
          {
            headers: this.authorization()
          }
        )
        .then(response => {
          console.log(response)
          vm.$refs.edit_item_modal.close()
          this.loadItems()
        })
        .catch(e => {
          this.errors.push(e)
          this.PageSelectisDisabled = false
        })
    },

    loadFilterObjects: function(e) {
      this.$axios
        .get(`/api/items/filter_objects`, {
          headers: {
            authorization: this.$ls.get('access_token')
          }
        })
        .then(response => {
          // JSON responses are automatically parsed.
          this.filter_objects = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    greet: function(el) {
      var _status = el.status == true ? false : true

      this.$axios
        .patch(
          `/api/properties/` + el.id,
          {
            property: {
              status: _status
            }
          },
          this.auth()
        )
        .then(response => {
          // JSON responses are automatically parsed.
          this.updateRow(response.data.data)
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    updateRow: function(row) {
      var foundIndex = this.properties.findIndex(x => x.id == row.id)
      this.$set(this.properties, foundIndex, row)
    }
  }
}
</script>

<style lang="scss">
@import './sass/items.scss';
</style>
